import Route from '@ember/routing/route';

export default class UseVoucherRoute extends Route {}
